var SocialFaqsPortlet = {
  init: function(socialMaxFaq) {
    this.setVariables();
    this.retrieveFaqs();
	this.socialMaxFaq = socialMaxFaq;
  },
  setVariables: function() {
    this.$faqsList = $("#socialFaqsList");
    this.$faqMoreLink = $("#faqMoreLink");
    this.$noContent = $("#noSocialFaqs");
  },
  retrieveFaqs: function() {
    var url = Config.contextPath + "/controller/view/faq/"
    var data = {
      SToken: Config.csrf.value,
      format: "json"
    };

    $.post(url, data)
      .done($.proxy(this.handleResponse, this));
  },
  handleResponse: function(r) {
    var MAX_FAQ_COUNT = this.socialMaxFaq,
      count = 0,
      showMore = false,
      faqs;

    var hasItems = r !== undefined && r.faqs !== undefined && r.faqs.length > 0;

    if (!hasItems) {
      this.showNoContent();
      return;
    }

    var faqs = r.faqs.filter(function(faq) {
      return faq.isActive;
    });

    if (faqs.length == 0) {
      this.showNoContent();
      return;
    }

    if (faqs.length > MAX_FAQ_COUNT) {
      faqs = faqs.slice(0, Math.min(faqs.length, MAX_FAQ_COUNT));
      showMore = true;
    }

    faqs = faqs.map(this.getFaqItem);
    this.$faqsList.append(faqs);

    if (showMore) {
      this.$faqMoreLink.removeClass("hide");
    }
  },
  showNoContent: function() {
    this.$noContent.removeClass("hide");
    this.$faqsList.addClass("hide");
  },
  getFaqItem: function(faq) {
    var $li = $("<li></li>");
    var $href = $("<a></a>");

    $href.attr("href", Config.contextPath + "/controller/view/faq/?id=" + faq.id);
    $href.html(faq.question);
    $li.append($href);

    return $li;
  }
};